'use strict';

import React from 'react';
import Dialog from 'material-ui/Dialog';
import {Link} from 'react-router';
import DocumentTitle from 'react-document-title';
import SearchFarmersStore from "../../stores/SearchFarmersStore.js";
import * as Connections from "../../utils/Connections.js";
import ProduceStore from "../../stores/ProduceStore";
import $ from "jquery";
import * as Cookies from "../../utils/Cookies";
import {searchFarmer} from "../../utils/Connections";

let tempStyle = {
    marginBottom: '80px'
};
let searchBarPadding = {
    paddingBottom: "1vw"
}
const styles = {
    modal: {
        borderRadius: '0'
    },
    marginSide: {
        marginLeft: '1em'
    },
    date: {
        marginTop: "0px !important"
    }
};
let imageStyle = {
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundImage: 'https://client.khula.co.za/images/user-medium.png',
};

class Farmers extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            allFarmers: [],
            produceList: ProduceStore.getAll(),
            searchMode: false,
            distance: "1",
            openFilters: false,
            filteredProduce: [],
            combinedNames: "",
            selectName: "",
            editMode: true,
            organic: "False",
            isFilterBased: false,
            displayDistance: "",
            displayProduce: "",
            displayOrganic: "",
            searchName:""

        };
        this.updateSearchedFarmers = this.updateSearchedFarmers.bind(this);
        this.handleFarmerStatus = this.handleFarmerStatus.bind(this);
        this.updateDistance = this.updateDistance.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.updateProduceList = this.updateProduceList.bind(this);
        this.handleProduceChange = this.handleProduceChange.bind(this);
        this.addProduce = this.addProduce.bind(this);
        this.applyFilters = this.applyFilters.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.openFilters = this.openFilters.bind(this);
        this.updateOrganic = this.updateOrganic.bind(this);
    }

    updateOrganic() {
        var lfckv = document.getElementById("checkOrganic").checked;
        if (lfckv) {
            this.setState({
                organic: "True",
                displayOrganic: "Organic:True"
            })
        } else {
            this.setState({
                organic: "False",
                displayOrganic: "Organic:False"
            })
        }
    }

    updateProduceList() {
        this.setState({
            produceList: ProduceStore.getAll(),
        }, function () {
            console.log(this.state.produceList);
            this.setState({
                selectName: this.state.produceList[0].name
            })
        });
    }

    handleProduceChange(produceName) {
        this.setState({
            selectName: produceName
        }, function () {
            this.addProduce()
        })
    }

    applyFilters() {
        var self=this;
        this.setState({
            openFilters: false,
            isFilterBased: true,
            displayDistance: "Distance:" + this.state.distance + " KM",
            displayProduce: "Produce:" + this.state.combinedNames,
            displayOrganic: "Organic:false",
            searchMode: true
        }, function () {
            self.searchFarmers(this.state.searchName);
        });

    }

    clearFilters() {
        var self = this;
        this.setState({
            isFilterBased: false,
            displayDistance: "",
            displayOrganic: "",
            displayProduce: "",
            searchMode: false
        }, function () {
            self.updateSearchedFarmers();
        })
    }

    openFilters() {
        this.setState({
            openFilters: true
        })
    }

    addProduce() {
        var isPart = false;
        for (var i = 0; i < this.state.filteredProduce.length; i++) {
            if (this.state.selectName == this.state.filteredProduce[i].name) {
                isPart = true;
            }
        }
        if (!isPart) {
            for (var i = 0; i < this.state.produceList.length; i++) {
                if (this.state.selectName == this.state.produceList[i].name) {
                    var get = this.state.filteredProduce;
                    var comb = this.state.combinedNames == "" ? this.state.selectName : this.state.combinedNames + ',' + this.state.selectName;
                    get[get.length] = this.state.produceList[i];
                    this.setState({
                        filteredProduce: get,
                        combinedNames: comb
                    });
                }
            }
        }
    }

    updateDistance(get) {
        this.setState({
            distance: get
        })
    }

    handleClose() {
        this.setState({openFilters: false});
    };

    componentWillMount() {
        this.setState({
            allFarmers: SearchFarmersStore.getAll()
        });
        SearchFarmersStore.on("change", this.updateSearchedFarmers);
        ProduceStore.on("change", this.updateProduceList);
        Connections.getMyPreferredFarmers();
    }

    updateSearchedFarmers() {
        if (this.state.searchMode == false) {
            this.setState({
                allFarmers: SearchFarmersStore.getMyFarmers()
            });
        } else {
            this.setState({
                allFarmers: SearchFarmersStore.getAll()
            });
        }
    }

    handleFarmerStatus(farmer) {
        if (farmer.isMine == true) {
            Connections.removeFromMyPreferredFarmers(farmer.id)
        } else {
            Connections.addToMyPreferredFarmers(farmer);
        }
    }

    searchFarmers(e) {
        this.setState({
            searchName: e
        }, function () {

            var prod = "";
            for (var i = 0; i < this.state.filteredProduce.length; i++) {
                prod = i == 0 ? this.state.filteredProduce[i].id : prod + "," + this.state.filteredProduce[i].id;
            }
            if (this.state.isFilterBased) {
                var sendData = {
                    method: 'POST',
                    headers: new Headers({
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }),
                    body: $.param({
                        type: "searchFarmersWithFilters",
                        token: Cookies.checkCookie("accessToken"),
                        searchText: e,
                        distance: this.state.distance,
                        organic: this.state.organic,
                        produceName: prod
                    })

                };
                Connections.searchFarmerWithFilters(sendData);
            } else {
                if (e.trim().length > 2) {
                    Connections.searchFarmer(e);
                    this.setState({
                        searchMode: true
                    });
                } else {
                    SearchFarmersStore.handleActions({type: "CLEAR_SEARCH_FARMERS"});
                    this.setState({
                        searchMode: false
                    });
                    SearchFarmersStore.justEmit();

                }
            }

        })
    }


    getPictureLink(imageName) {
        return Connections.getProfileImageLink() + imageName;
    }

    render() {
        const actions = [
            <button onClick={this.handleClose} className="uk-button uk-button-default " type="button">Cancel</button>,
            <button style={styles.marginSide} className="uk-button uk-button-primary" type="button"
                    onClick={this.applyFilters}>Apply Filters</button>
        ];
        return (

            <DocumentTitle title="Khula - Favorite farmers">
                <div className="main-content">
                    <div>
                        <div className="row">
                            <form style={searchBarPadding} className="col-sm-8 col-xs-8 col-lg-8 col-md-8"><br></br>
                                <div className="input-group">
                                    <input type="text" className="form-control" placeholder="Search"
                                           value={this.state.searchName}
                                           onChange={(e) => this.searchFarmers(e.target.value)}/>
                                    <span className="input-group-btn"><button type="button"
                                                                              className="btn btn-primary">Go</button></span>
                                </div>
                            </form>
                            <div style={searchBarPadding} className="col-sm-4 col-xs-4 col-lg-4 col-md-4">
                                <button className="btn btn-primary" onClick={this.clearFilters}>Clear filters</button>
                                <button className="btn btn-primary" onClick={this.openFilters}>Add filters</button>
                                <div>
                                    <strong>{this.state.displayOrganic}</strong><br></br>
                                    <strong>{this.state.displayProduce}</strong><br></br>
                                    <strong>{this.state.displayDistance}</strong>
                                </div>
                            </div>
                        </div>
                        <div className="uk-grid-small uk-flex-row uk-text-center" uk-grid>

                            {this.state.allFarmers.map((farmer, i) =>
                                <div style={tempStyle} className="col-sm-6 col-xs-12 col-lg-3 col-md-3" key={farmer.id}>
                                    <div className="wrapper uk-card uk-card-hover" style={{backgroundColor: 'white'}}>
                                        <div className="card radius shadowDepth1">
                                            <div className="card__image border-tlr-radius">
                                                <img src={this.getPictureLink(farmer.image_name)} alt=""
                                                     className="border-tlr-radius"/>
                                            </div>
                                            <div className="card__content card__padding">
                                                <article className="card__article">
                                                    <h4>{farmer.name} {farmer.surname}</h4>
                                                    <div className="card__meta">
                                                        <time>South Africa</time>
                                                    </div>
                                                    <p className="setViewFarmerProduce">{farmer.produce_farming.map((pro, i) =>
                                                        <label>{pro.name} | </label>
                                                    )}</p>
                                                </article>
                                            </div>
                                        </div>
                                        <div className="uk-card-footer">
                                            <a className="uk-button uk-button-text"
                                               onClick={(e) => this.handleFarmerStatus(farmer)}>{farmer.isMine == true ? "Remove" : "Add"}</a>
                                        </div>

                                    </div>

                                </div>
                            )}
                        </div>
                    </div>

                    <Dialog
                        title={<h3 className="uk-modal-title">Add Filters</h3>}
                        modal={false}
                        open={this.state.openFilters}
                        actions={actions}
                        onRequestClose={this.handleClose}
                        autoScrollBodyContent={true}>

                        <form style={{marginTop: '10px'}}>
                            <fieldset className="uk-fieldset">
                                <div className="uk-margin">
                                    <div className="row">
                                        <div className="col-sm-12 col-xs-12 col-lg-12 col-md-12">
                                            <label> Max Distance <br></br>{this.state.distance} KM</label>
                                            <div class="slidecontainer">
                                                <input type="range" min="1" max="100" value={this.state.distance}
                                                       class="slider" id="myRange"
                                                       onChange={(e) => this.updateDistance(e.target.value)}/>
                                            </div>
                                            <br></br>
                                            <div></div>
                                            <label>{this.state.combinedNames}</label>
                                            <br></br>
                                            <br></br>
                                            <label>Add Produce Name</label>
                                            <select className="uk-select" id="produce-selector"
                                                    onChange={(e) => this.handleProduceChange(e.target.value)}>
                                                {
                                                    this.state.produceList.map((produceItem, i) => {
                                                        return <option
                                                            key={produceItem.id + "select"}>{produceItem.name}</option>
                                                    })
                                                }
                                            </select>
                                            <br></br>

                                            <label>Organic</label>
                                            <br></br>
                                            <label class="switch">
                                                <input type="checkbox" id="checkOrganic" onChange={this.updateOrganic}/>
                                                <span class="checker round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </form>
                    </Dialog>
                </div>
            </DocumentTitle>
        );
    }

}


export default Farmers;



// WEBPACK FOOTER //
// ./src/pages/HopePageBabies/Farmers.js